
import { getReferrerInfo, getUTMParameters } from './referrerTracking';
import { detectBrowser } from './device/browserDetection';
import { detectOS } from './device/osDetection';
import { detectPlatform } from './device/platformDetection';
import { getSessionId } from './device/sessionUtils';

export interface DeviceInfo {
  platform: string;
  browser: string;
  os: string;
  language: string;
  timezone: string;
  screen_resolution: string;
  viewport_size: string;
  user_agent: string;
  referrer_category: string;
  referrer_source?: string;
  bot_type?: string;
  utm_params?: Record<string, string>;
  session_id: string;
  timestamp: string;
}

export const getDeviceInfo = (): DeviceInfo => {
  const userAgent = navigator.userAgent || 'unknown';
  const referrerInfo = getReferrerInfo(userAgent);
  const utmParams = getUTMParameters();
  
  return {
    platform: detectPlatform(),
    browser: detectBrowser(),
    os: detectOS(),
    language: navigator.language || 'unknown',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
    screen_resolution: `${screen.width}x${screen.height}` || 'unknown',
    viewport_size: `${window.innerWidth}x${window.innerHeight}` || 'unknown',
    user_agent: userAgent,
    referrer_category: referrerInfo.category,
    referrer_source: referrerInfo.source,
    bot_type: referrerInfo.botType,
    utm_params: Object.keys(utmParams).length > 0 ? utmParams : undefined,
    session_id: getSessionId(),
    timestamp: new Date().toISOString()
  };
};

// Re-export getSessionId for other modules that need it
export { getSessionId } from './device/sessionUtils';
